import { render } from "./RhTextarea.vue?vue&type=template&id=6bfb6876&scoped=true&ts=true"
import script from "./RhTextarea.vue?vue&type=script&lang=ts"
export * from "./RhTextarea.vue?vue&type=script&lang=ts"

import "./RhTextarea.vue?vue&type=style&index=0&id=6bfb6876&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bfb6876"]])

export default __exports__